export const witholdingTax = 3

export enum TypePackage {
  Package = 'package',
  Bundle = 'bundle',
}

export enum PeriodType {
  Day = 1,
  Month = 2,
  Year = 3,
}

export enum PaymentChannel {
  CreditCard = 1,
  IOS = 3,
  Android = 5,
  AIS_USSD = 7,
  AttachSlip = 9,
  PrePaidSerial = 11,
  Manual = 13,
  QRcode = 15,
  RedeemCredit = 17
}

export enum PackageStatus {
  Pending = 10,
  Approve = 30,
  Suspend = 50,
  Terminated = 70,
  Delete = 90,
}

export enum SubscriptionType {
  Package = 1,
  Bundle = 2,
  AddOn = 3,
}

export enum UpgradeType {
  Upgrade = 1,
  Renew = 3,
  ChangePackage = 5,
}

export enum DiscountType {
  Percent = 1,
  Value = 3,
}

export enum PackageLevel {
  Free = 0,
  Standard = 1,
  Pro = 2,
  ProBusiness = 3,
}

export enum PackageIdList {
  MonthlyLevel1 = 119,
  MonthlyLevel2 = 121,
  MonthlyLevel3 = 117,
  YearlyLevel1 = 118,
  YearlyLevel2 = 120,
  YearlyLevel3 = 116,
}
